import {Component, Input, OnInit} from '@angular/core';
import {NewsItem} from '../model/news-item';

@Component({
    selector: 'news-list',
    templateUrl: './news-list.component.html',
    styleUrls: ['./news-list.component.scss']
})
export class NewsListComponent implements OnInit {

    @Input() articles: NewsItem[] = [];

    constructor() { }

    ngOnInit(): void { }
}
